module.exports = __webpack_public_path__ + "static/media/bg-faq-mrh.ea3a2260.svg";